import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionIdMatch = hash.match(/session_id=([^&]+)/);

    if (!sessionIdMatch) {
      navigate('/login');
      return;
    }

    const sessionId = sessionIdMatch[1];

    const exchangeSession = async () => {
      try {
        await axios.post(
          `${API_URL}/api/auth/google`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        // Clear hash and refresh auth
        window.history.replaceState(null, '', window.location.pathname);
        const userData = await checkAuth();
        if (userData && !userData.onboarding_complete) {
          navigate('/onboarding', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } catch (err) {
        console.error('OAuth error:', err);
        navigate('/login', { replace: true });
      }
    };

    exchangeSession();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-[#E11D48] animate-spin mx-auto mb-4" />
        <p className="text-[#A1A1AA] text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
